import { jsx as r } from "react/jsx-runtime";
import { ae as a } from "../../../vendor-CPVnY93G.js";
import '../../../assets/index31.css';const o = "_header_115xv_1", d = {
  header: o
};
function c({ children: e }) {
  return /* @__PURE__ */ r(a, { className: d.header, children: e });
}
export {
  c as Header
};
